// localStorage persistence
const STORAGE_KEY = "geoh-v1";

export function fetch() {
  const locations = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
  return locations;
}

export function save(locations) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(locations));
}
